import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { season_icons } from "../../../components/ShopForTyres";
import { GetOrder } from "../../actions/orders";
import close from "../../assets/cancel.svg";
import PopupComponent from "../../common/Popup";
import Table from "../../common/Table";
import { amountFormat } from "../../config/helper";
import ShopForTyres from "../ShopForTyres";

const ProdDetailTable = ({ data, order, isEdit, products, setProducts }) => {
  const [isShowProducts, setIsShowProducts] = useState(false);
  const dispatch = useDispatch();
  const columns = [
    {
      header: "SKU",
      accessor: "SKU",
      width: 10,
    },
    {
      header: "Rim",
      accessor: "rim",
      width: 5,
    },
    {
      header: "Size",
      accessor: "Size",
      width: 8,
    },
    {
      header: "LI",
      accessor: "li",
      width: 5,
    },
    {
      header: "SR",
      accessor: "sr",
      width: 5,
    },
    {
      header: "LR",
      accessor: "lr",
      width: 5,
    },
    {
      header: "Pattern",
      accessor: "Pattern",
      width: 8,
    },
    {
      header: "Category",
      accessor: "category",
      width: 8,
      cell: (row) => (
        <img
          src={season_icons[row?.category?.trim()?.toLowerCase()]}
          className={row?.category?.trim()?.toLowerCase()}
          alt="season"
        />
      ),
    },
    {
      header: "Application",
      accessor: "appliction",
      width: 8,
    },
    {
      header: "Unit Price",
      accessor: "Unit Price",
      width: 10,
      cell: (row) => `$${parseFloat(row?.["Unit Price"]).toFixed(2)}`,
    },
    {
      header: "Quantity Ordered",
      accessor: "Quantity",
      width: 15,
    },
    {
      header: "Amount",
      accessor: "Amount",
      width: 19,
      cell: (row) => `$${amountFormat(row?.["Unit Price"] * row?.Quantity)}`,
    }]

  return (
    <div className="prod-detail">
      <Table
        columns={columns}
        data={data}
        showTotal={true}
        totalPrice={order?.total_price}
        totalQuantity={order?.total_quantity}
        isCancel={isEdit}
        delete={(id) => {
          let idx = data.findIndex((ele) => ele.id === id);
          if (idx > -1) {
            let prodId = data[idx].product_id;
            let prods = [...products];
            let idx1 = prods.findIndex((ele) => ele.product_id === prodId);
            if (idx1 > -1) {
              prods[idx].quantity = 0;
              setProducts(prods);
            }
          }
        }}
        orderEdit={isEdit}
        orderEditAction={() => {
          setIsShowProducts((bool) => !bool);
        }}
      />
      <PopupComponent open={isShowProducts} width={1400} height={580}>
        <div>
          <img
            src={close}
            alt="close"
            width={20}
            style={{
              position: "absolute",
              right: 20,
              top: 10,
              cursor: "pointer",
            }}
            onClick={() => setIsShowProducts(false)}
          />
          <ShopForTyres
            noNav={true}
            fromOrder={true}
            fromOrderCart={(item) => {
              let obj = {
                product_id: item.id,
                quantity: parseInt(item.quantity),
                unit_price: item.unit_price
              };
              dispatch({
                type: GetOrder.CHANGED,
                line_item: item,
              });
              let idx = products.findIndex((ele) => ele.product_id === item.id);
              if (idx > -1) {
                let prods = [...products];
                prods[idx].quantity = parseInt(item.quantity);
                setProducts(prods);
              } else {
                setProducts([...products, obj]);
              }
            }}
            line_items={data}
          />
        </div>
      </PopupComponent>
    </div>
  );
};

export default ProdDetailTable;
